// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1hEXl","boxTitle":"Qualiphy_boxTitle__3jb75","box":"Qualiphy_box__2b0v0","toggleWrap":"Qualiphy_toggleWrap__3MA3k"};